import { render, staticRenderFns } from "./ViRegisterSchoolIndividual.vue?vue&type=template&id=a074da7c&scoped=true"
import script from "./ViRegisterSchoolIndividual.vue?vue&type=script&lang=js"
export * from "./ViRegisterSchoolIndividual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a074da7c",
  null
  
)

export default component.exports